import { MagicWandInput } from "@/modules/chats/services/ai/ch/__generated__/chMagicWandQuery.graphql"
import { chMagicWandQuery } from "@/modules/chats/services/ai/ch/chMagicWandQuery"
import { deMagicWandQuery } from "@/modules/chats/services/ai/de/deMagicWandQuery"
import { Country } from "@/types/__generated__/union-types"

export const magicWandQuery = (country: Country, input: MagicWandInput) => {
  if (country === "DE") {
    return deMagicWandQuery(input)
  }
  return chMagicWandQuery(input)
}
